export const mockTaskAutoAssignmentRules = [
  {
    id: '1',
    name: 'Rule 1',
    partnerId: 'partner-1',
    taskTemplates: [{ taskTemplateId: 't1' }],
    taskTemplateNames: ['Template 1'],
    accounts: [{ accountId: 'a1' }, { accountId: 'a2' }],
    countries: [{ countryCode: 'US' }],
    nominatorGroups: []
  },
  {
    id: '2',
    name: 'Rule 2',
    partnerId: 'partner-2',
    taskTemplates: [{ taskTemplateId: 't2' }],
    taskTemplateNames: ['Template 2'],
    accounts: [{ accountId: 'a3' }],
    countries: [{ countryCode: 'GB' }, { countryCode: 'FR' }],
    nominatorGroups: []
  }
]
